export default __webpack_public_path__ + "static/checked-c8721b8aed6c4e48d96cd3a2cd7c7ab9.png";